import { defineComponent } from 'vue';
import CategoryElevenComponent from '@/components/CategoryEleven/CategoryElevenComponent.vue';
export default defineComponent({
    name: 'CategoryEleven',
    components: { CategoryElevenComponent },
    data() {
        return {};
    }
});
